import { ArrowUpRight, Check } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { useSite } from "../context/SiteContext";
import { GALLERY_PHOTOS, OFFERS, track, whatsappLink } from "../lib/site";

export default function Offers() {
  const { openBooking, settings } = useSite();
  return (
    <main>
      <PageHero
        image={GALLERY_PHOTOS[3]}
        eyebrow="Offers & Packages"
        lines={[<>Reasons to</>, <em>linger longer.</em>]}
        lede="Four considered packages, each with its own pace. Book direct on WhatsApp or send a request — our desk will shape the details around your dates."
      />
      <section className="section-pad stay-section" data-testid="offers-list">
        <div className="offers-grid">
          {OFFERS.map((offer, i) => (
            <Reveal key={offer.id} delay={(i % 2) * 0.1} className="offer-card" data-testid={`offer-card-${offer.id}`}>
              <div className="offer-image"><img src={offer.image} alt={offer.name} loading="lazy" /><span>{String(i + 1).padStart(2, "0")}</span></div>
              <div className="offer-body">
                <h3>{offer.name}</h3>
                <p className="offer-tagline">{offer.tagline}</p>
                <ul>
                  {offer.inclusions.map((item) => <li key={item}><Check size={14} /> {item}</li>)}
                </ul>
                <div className="offer-actions">
                  <button className="gold-button" onClick={() => { track("offer_enquiry", { offer: offer.name }); track("book_now_click", { location: "offers_page", offer: offer.name }); openBooking({ offer }); }} data-testid={`offer-book-${offer.id}`}>
                    Book this offer <ArrowUpRight size={15} />
                  </button>
                  <a
                    className="text-link"
                    href={whatsappLink(`Hello Madhubhan Resort & Spa, I would like to know more about the ${offer.name} package.`, settings.whatsapp)}
                    target="_blank" rel="noreferrer"
                    onClick={() => track("whatsapp_click", { location: "offers_page", offer: offer.name })}
                    data-testid={`offer-whatsapp-${offer.id}`}
                  >
                    Ask on WhatsApp
                  </a>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </main>
  );
}
